export const getBrowserLangs = (): readonly string[] => {
  return window.navigator.languages || ['en'];
};
